require.register("ffss/component/Menu", function(exports, require, module){
  $0
  
});

